import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import countries from './countries';
import PropTypes from '../types';

const Country = ({ ...props }) => {
  let countryItems = countries.map((country) => ({ id: country.name, labelText: country.name }));
  if (props.removeCountries && props.removeCountries.length > 0) {
    props.removeCountries.map((country) => country !== countries);
    const filteredCountries = countries.filter(
      (country) => props.removeCountries.indexOf(country.name) < 0
    );
    const filteredOptions = filteredCountries.map((country) => ({
      id: country.name,
      labelText: country.name
    }));
    countryItems = filteredOptions;
  }

  return <GenericSelect {...props} selectedId={props.value} items={countryItems} />;
};

Country.propTypes = {
  removeCountries: PropTypes.object
};

export default Country;
